import { Counter } from "@/components";
import useSummary from "./useSummary";

const Summary = () => {
  const { summaryData } = useSummary();

  return (
    <div style={{
    background: "linear-gradient(270.95deg, #136A85 0%, #00A3D4 87.52%)",
  }}>
      <div className="mx-10 lg:mx-0 grid grid-cols- md:grid-cols-3 lg:grid-cols-7 px-5 py-7 text-white">
        {summaryData?.map((data, index) => (
          <div
            key={data.title}
            className="flex flex-col items-center justify-center gap-1 relative p-4"
          >
            <img src={data.icon} className="h-8 w-8" />
            <span className="text-[32px] font-bold">
              <Counter end={Number(data.count)} />
              {data?.prefix || ""}+
            </span>
            <span className="text-[17.5px] opacity-[0.7]">{data.title}</span>
            {index != summaryData?.length - 1 ? (
              <div className="w-[0.5px] h-full absolute right-0 bg-white opacity-[0.8] hidden lg:block" />
            ) : (
              <></>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Summary;
